import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { PaymentRequestStatus } from '@src/types';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import styles from './PaymentRequestStatusTag.module.scss';
const getColors = (status) => {
    let outline = 'background-color-1';
    const text = 'text-color-1';
    let bg = 'background-color-1-tint-1';
    switch (status) {
        case PaymentRequestStatus.INFO_REQUESTED:
        case PaymentRequestStatus.AWAITING_DOCUMENTS:
            outline = 'background-color-3';
            bg = 'background-color-3-lighten-50';
            break;
        case PaymentRequestStatus.READY_FOR_PAYMENT:
        case PaymentRequestStatus.APPROVED:
            outline = 'background-color-4';
            bg = 'background-color-4-lighten-50';
            break;
        case PaymentRequestStatus.REJECTED:
        case PaymentRequestStatus.EXPIRED:
        case PaymentRequestStatus.CLOSED:
        case PaymentRequestStatus.CANCELLED:
            outline = 'background-color-2';
            bg = 'background-color-2-lighten-50';
            break;
    }
    return {
        outline,
        text,
        bg,
    };
};
export const PaymentRequestStatusTag = ({ paymentRequest, size = 'small', separateInReviewState = false, }) => {
    const { t } = useLocale();
    // Use APPROVED color for ACTIVE status when funds are earmarked
    const isEarmarked = paymentRequest.status === PaymentRequestStatus.ACTIVE &&
        paymentRequest.amountRequested &&
        paymentRequest.amountEarmarked;
    const effectiveStatus = isEarmarked ? PaymentRequestStatus.APPROVED : paymentRequest.status;
    const { outline, text, bg } = getColors(effectiveStatus);
    const statusDisplay = useMemo(() => {
        if (paymentRequest.status === PaymentRequestStatus.READY_FOR_PAYMENT) {
            return !paymentRequest.amountRequested ||
                !paymentRequest.amountToPay ||
                paymentRequest.amountRequested !== paymentRequest.amountToPay
                ? t('Partially approved')
                : t(`paymentRequestStatus.${paymentRequest.status}`);
        }
        else if (isEarmarked) {
            return paymentRequest.amountRequested > paymentRequest.amountEarmarked
                ? t('Funds partially approved')
                : t('Funds approved');
        }
        else {
            if (separateInReviewState && paymentRequest.status === PaymentRequestStatus.IN_REVIEW) {
                return t('Manager review');
            }
            return t(`paymentRequestStatus.${paymentRequest.status}`);
        }
    }, [paymentRequest, t, separateInReviewState, isEarmarked]);
    return (_jsx("div", { children: _jsx("div", { className: classNames(styles.tag, size === 'large' && styles.large), style: {
                color: `var(--${text})`,
                backgroundColor: `var(--${bg})`,
                borderColor: `var(--${outline})`,
            }, children: _jsx(Typography, { variant: size === 'large' ? 'body1' : 'label2', weight: '400', className: styles.status, children: statusDisplay }) }) }));
};
